/* eslint-disable no-empty */
import {
    criptObjectOnLocalStorage,
    criptoLocalStorage,
    decriptoLocalStorage
} from '../cripotografia/criptoStorage';

export const setUser = response => {
    const NomeCoordenador = decriptoLocalStorage('NomeCoordenador')?.decriptoValue;
    const NomeSupervisor = decriptoLocalStorage('NomeSupervisor')?.decriptoValue;
    const CodSupervisor = decriptoLocalStorage('codSupervisor')?.decriptoValue;
    const codCoordenador = decriptoLocalStorage('codCoordenador')?.decriptoValue;
    const codigo_vendedor = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
    const link = decriptoLocalStorage('Link')?.decriptoValue;
    const codigo = decriptoLocalStorage('Codigo')?.decriptoValue;

    criptObjectOnLocalStorage('log', decriptoLocalStorage('email')?.decriptoValue);
    criptObjectOnLocalStorage('escritorio', response['Alocacao.filial']);
    criptObjectOnLocalStorage('idLocalidade', response['Alocacao.idLocalidade']);

    if (decriptoLocalStorage('Nome')?.decriptoValue == 'undefined') {
        criptoLocalStorage('Nome', response.Nome);
    } else if (decriptoLocalStorage('Nome')?.decriptoValue) {
    } else {
        criptoLocalStorage('Nome', response.Nome);
    }

    if (decriptoLocalStorage('Email')?.decriptoValue == 'undefined') {
        criptoLocalStorage('Email', response.Email);
    } else if (decriptoLocalStorage('Email')?.decriptoValue) {
    } else {
        criptoLocalStorage('Email', response.Email);
    }

    if (codigo == 'undefined') {
        criptoLocalStorage('Codigo', response.CPF);
    } else if (codigo) {
    } else {
        criptoLocalStorage('Codigo', response.CPF);
    }

    if (link == 'undefined') {
        criptoLocalStorage('Link', response.Link);
    } else if (link) {
    } else {
        criptoLocalStorage('Link', response.Link);
    }

    if (codigo_vendedor == 'undefined') {
        criptoLocalStorage('codigo_vendedor', response.codigo);
    } else {
        criptoLocalStorage('codigo_vendedor', response.codigo);
    }

    if (CodSupervisor == 'undefined') {
        criptoLocalStorage(
            'codSupervisor',
            response['Supervisor'] !== null ? response['Supervisor'] : ''
        );
    } else if (CodSupervisor) {
        criptoLocalStorage(
            'codSupervisor',
            response['Supervisor'] !== null ? response['Supervisor'] : ''
        );
    } else {
        criptoLocalStorage(
            'codSupervisor',
            response['Supervisor'] !== null ? response['Supervisor'] : ''
        );
    }

    if (codCoordenador == 'undefined') {
        criptoLocalStorage(
            'codCoordenador',
            response['Coordenador'] !== null ? response['Coordenador'] : ''
        );
    } else if (codCoordenador) {
        criptoLocalStorage(
            'codCoordenador',
            response['Coordenador'] !== null ? response['Coordenador'] : ''
        );
    } else {
        criptoLocalStorage(
            'codCoordenador',
            response['Coordenador'] !== null ? response['Coordenador'] : ''
        );
    }

    if (NomeSupervisor == 'undefined') {
        criptoLocalStorage(
            'NomeSupervisor',
            response['Supervisore.Nome'] !== null ? response['Supervisore.Nome'] : ''
        );
    } else if (NomeSupervisor) {
        criptoLocalStorage(
            'NomeSupervisor',
            response['Supervisore.Nome'] !== null ? response['Supervisore.Nome'] : ''
        );
    } else {
        criptoLocalStorage(
            'NomeSupervisor',
            response['Supervisore.Nome'] !== null ? response['Supervisore.Nome'] : ''
        );
    }

    if (NomeCoordenador == 'undefined') {
        criptoLocalStorage(
            'NomeCoordenador',
            response['Coordenadore.Nome'] !== null ? response['Coordenadore.Nome'] : ''
        );
    } else if (NomeCoordenador) {
        criptoLocalStorage(
            'NomeCoordenador',
            response['Coordenadore.Nome'] !== null ? response['Coordenadore.Nome'] : ''
        );
    } else {
        criptoLocalStorage(
            'NomeCoordenador',
            response['Coordenadore.Nome'] !== null ? response['Coordenadore.Nome'] : ''
        );
    }

    return true;
};
